<template>
  <v-col md="3" sm="4" cols="12" class="px-0 py-1">
    <v-card class="my-2 mr-1" elevation="2">
      <v-subheader ref="subheader">
        <!-- eslint-disable-next-line -->
        <v-checkbox
          hide-details
          color="primary"
          class="my-4"
          @change="companyCheckboxClicked"
          :input-value="allChecked"
          :indeterminate="indet"
        >
          <template v-slot:label>
            Company
            <v-chip color="primary" class="mx-2" small text-color="white">{{
              companyBenefits.length
            }}</v-chip>
          </template>
        </v-checkbox>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          small
          color="primary"
          v-if="showRemove"
          :disabled="companiesSelected.length === 0"
          @click="$emit('removeSelected')"
          >Remove Selected</v-btn
        >
      </v-subheader>
      <!-- eslint-disable-next-line -->
      <v-text-field
        append-icon="search"
        clearable
        single-line
        hide-details
        solo
        flat
        v-model="companySearchText"
        background-color="light-green lighten-5"
      ></v-text-field>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ml-12 my-2"
        v-if="loading"
      ></v-progress-circular>

      <v-virtual-scroll
        :bench="8"
        :items="companyBenefitsFiltered"
        :height="companyListHeight + 150"
        item-height="58"
        class="text-subtitle-2 overflow-x-auto"
      >
        <template v-slot:default="{ item }">
          <v-checkbox
            @change="selectionChanged(item.company, $event)"
            style="width:100%;padding-top:12px;padding-bottom:12px;"
            class="hoverable px-4 my-0 overflow-x-auto"
            v-show="!loading"
            @mouseover.native.stop.prevent="hover(item)"
            @mouseleave.native.stop.prevent="leave(item)"
            :input-value="companiesSelected.includes(item.company)"
            color="primary"
            slot="activator"
            hide-details
            single-line
          >
            <span slot="label"
              ><span>{{ item.company }}</span>
              <v-chip
                :color="item.allPositionsSelected ? 'primary' : 'primary lighten-4'"
                class="ml-1 mt-0 mb-0"
                small
                outlined
                @click.stop.prevent="showIncumbents($event, item)"
              >
                {{ item.positions.length }}
                <v-icon class="pl-1">people</v-icon>
              </v-chip>
            </span>
          </v-checkbox>
        </template>
      </v-virtual-scroll>
    </v-card>
  </v-col>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      companySearchText: '',
    };
  },
  methods: {
    selectionChanged(company, e) {
      const compSelected = new Set(this.companiesSelected);
      if (e) {
        compSelected.add(company);
      } else {
        compSelected.delete(company);
      }
      this.$emit('update:companiesSelected', Array.from(compSelected));
    },
    showIncumbents(e, company) {
      this.$emit('showIncumbents', {
        x: e.clientX,
        y: e.clientY,
        company,
      });
    },
    companyCheckboxClicked(e) {
      if (e) {
        this.$emit(
          'update:companiesSelected',
          this.companyBenefits.map((cb) => cb.company),
        );
      } else {
        this.$emit('update:companiesSelected', []);
      }
    },
    leave(e) {
      if (this.companyOnHover === e.company) {
        this.$emit('update:companyOnHover', '');
      }
    },
    hover(e) {
      if (e.company === this.companyOnHover) {
        return;
      }
      this.$emit('update:companyOnHover', e.company);
    },
  },
  computed: {
    allChecked() {
      if (!this.companiesSelected.length) return false;
      return this.companiesSelected.length === this.companyBenefits.length;
    },
    indet() {
      return (
        this.companiesSelected.length > 0
        && this.companiesSelected.length !== this.companyBenefits.length
      );
    },
    companyBenefitsFiltered() {
      if (!this.companySearchText || this.companySearchText.trim().length === 0) {
        const out = this.companyBenefits;
        return out;
      }
      // eslint-disable-next-line max-len
      const out = this.companyBenefits.filter((c) => c.company.toLowerCase().includes(this.companySearchText.trim().toLowerCase()));
      return out;
    },
  },
  mounted() {
    this.$emit('update:headerHeight', this.$refs.subheader.$el.clientHeight);
  },
  props: {
    companiesSelected: {
      type: Array,
      required: true,
    },
    companyBenefits: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    headerHeight: {
      type: Number,
    },
    companyListHeight: {
      type: Number,
    },
    companyOnHover: {
      type: String,
    },
    showRemove: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped>
.hoverable {
  position: relative;
  display: inline-block;
}
.hoverable:hover {
  background-color: rgba(100, 100, 100, 0.1);
}
</style>
